export const SCROLLABLE_CONTAINER_ID = 'scrollable_container'
export const AREA = 100
export const ADDITIONAL_OFFSET = 60